<template>
    <div id="AppProxyPay">
        <Row :gutter="16" style="margin-top: 12px">
            <Col span="5">
                <label style="display: flex; align-items: center">
                    <span style="width: 120px">转出类型:</span>
                    <Select clearable filterable placeholder="转出类型" v-model="table.params.type" @on-change="SearList">
                        <Option v-for="(item, index) in select.type_list" :value="item.value" :key="index" :label="item.name">
                            {{ item.name }}
                            <span style="color: #bbb">（{{ item.value }}）</span>
                        </Option>
                    </Select>
                </label>
            </Col>
            <Col span="5">
                <label style="display: flex; align-items: center">
                    <span style="width: 210px">用户卡号或账号:</span>
                    <Input type="text" clearable placeholder="用户卡号或账号" v-model="table.params.account" />
                </label>
            </Col>
            <Col span="13">
                <Button type="primary" @click="SearList" style="margin-right: 12px">搜索</Button>
            </Col>
            <Col span="1">
                <Button type="primary" style="float: right" @click="OpenModal1">导入风控账号</Button>
            </Col>
        </Row>

        <Table style="margin-top: 12px" border :ref="table.ref" :columns="table.columns" :data="table.data" :max-height="720" />
        <Page show-total show-sizer style="margin-top: 12px" :page-size="table.params.page_size" :total="table.page_total" :current="table.page_current" @on-change="ChangePage" @on-page-size-change="ChangePageSize" />

        <!-- 风控账号 -->
        <Modal v-model="modal1.show" @on-cancel="CloseModal1" width="850">
            <p slot="header" style="color: #1c2438">
                <span>导入风控账号</span>
            </p>
            <Form :model="modal2.form.data" :label-width="80">
                <Row>
                    <Col span="22">
                        <FormItem label="名单类型">
                            <RadioGroup v-model="modal1.form.data.type">
                                <Radio :label="1">银行卡号</Radio>
                                <Radio :label="2">支付宝账号</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="22">
                        <FormItem label="手动输入">
                            <Input type="textarea" v-model="modal1.form.data.lines" :rows="4" placeholder="输入转出账号，多次用逗号分隔，不超过100个"></Input>
                        </FormItem>
                    </Col>
                    <Col span="22">
                        <FormItem label="备注">
                            <Input type="text" v-model="modal1.form.data.desc"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div>
                <div style="position: relative">
                    <Upload type="drag" action>
                        <div style="padding: 20px 0; width: 65%; float: left">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p style="text-align: center">文件格式：【csv】的文件；</p>
                            <p style="text-align: center">文件大小：不大于1M；</p>
                        </div>
                        <div style="padding: 20px 0; width: 35%; float: left">
                            <p>上传文件示意图</p>
                            <table border="1" cellpadding="10" cellspacing="0" style="margin-left: 25%; width: 50%">
                                <tr>
                                    <th>card</th>
                                    <th>desc</th>
                                </tr>
                                <tr>
                                    <td>152****7845</td>
                                    <td>刷子1</td>
                                </tr>
                                <tr>
                                    <td>582****2222</td>
                                    <td>黑支付宝</td>
                                </tr>
                            </table>

                            <p style="margin-top: 10px">上传的文件内容必须带有表头，card代表转出账户，desc代表提示文本</p>
                        </div>
                    </Upload>
                    <input type="file" ref="upload" accept=".txt, .csv" class="outputlist_upload" />
                </div>
            </div>
            <div slot="footer">
                <Button style="margin-right: 12px">取消</Button>
                <Button type="primary" @click="ExportBlackPutInfo()">提交</Button>
            </div>
        </Modal>
        <!-- 更新备注信息 -->
        <Modal v-model="modal2.show" @on-cancel="CloseModal2">
            <div slot="header">编辑备注信息</div>
            <Form :model="modal2.form.data" :label-width="120">
                <Row>
                    <Col span="20">
                        <FormItem label="账号类型">
                            <RadioGroup v-model="modal2.form.data.type">
                                <Radio :label="1">银行卡</Radio>
                                <Radio :label="2">支付宝</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="用户账号">
                            <Input type="text" placeholder="用户账号" v-model="modal2.form.data.account" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="备注信息">
                            <Input type="text" placeholder="备注信息" v-model="modal2.form.data.desc" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <div slot="footer">
                <Button type="primary" @click="UpdateBlackPutInfo">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { ExportBlackPutInfo, SearchBlackPutInfo, UpdateBlackPutInfo, GetAllPlatform, DelBlackPutInfo } from '@/api/admin/risk'
export default {
    name: 'WithBlack',
    data() {
        return {
            select: {
                type_list: [
                    { name: '银行卡', value: 1 },
                    { name: '支付宝', value: 2 }
                ],
                platform_list: []
            },
            table: {
                ref: 'table',
                params: {
                    type: -1,
                    account: '',
                    page: 1,
                    page_size: 10
                },
                columns: [
                    {
                        title: '转出类型',
                        key: 'type',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => h('div', { style: { color: `${['#666', '#19be6b'][params.row.type - 1]}` } }, this.select.type_list[params.row.type - 1].name)
                    },
                    { title: '用户卡号或账号', key: 'account', minWidth: 100, align: 'center' },
                    { title: '限制提示信息', key: 'desc', minWidth: 100, align: 'center' },
                    { title: '创建时间', key: 'ctime', minWidth: 100, align: 'center' },
                    { title: '修改时间', key: 'utime', minWidth: 100, align: 'center' },

                    {
                        title: '管理',
                        align: 'center',
                        width: 160,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: { type: 'primary' },
                                        style: { marginRight: '5px' },
                                        on: {
                                            click: () => {
                                                this.OpenModal2(1, params.row)
                                            }
                                        }
                                    },
                                    '修改'
                                ),
                                h(
                                    'Button',
                                    {
                                        props: { type: 'error' },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: '确认删除',
                                                    onOk: () => {
                                                        this.Delete(params.row)
                                                    }
                                                })
                                            }
                                        }
                                    },
                                    '删除'
                                )
                            ])
                        }
                    }
                ],
                data: []
            },
            modal1: {
                show: false,
                form: {
                    ref: 'modal1_form',
                    data: {}
                }
            },
            modal2: {
                show: false,
                type: 'add',
                form: { ref: 'modal1_form', data: { config: {} } }
            }
        }
    },
    watch: {
        'modal1.show': function () {
            if (!this.modal1.show) {
                this.modal1.form.data = {}
            }
        }
    },
    methods: {
        ExportBlackPutInfo() {
            if (this.modal1.form.data.data || this.modal1.form.data.lines) {
                const param = { ...this.modal1.form.data }
                param.type = Number(param.type)
                if (param.lines) {
                    param.lines = param.lines.replace(/\，/gi, ',').replace(/\s/g, '')
                }
                ExportBlackPutInfo(param).then((res) => {
                    this.modal1.show = false
                    setTimeout(() => {
                        this.$Message.success('添加黑名单成功')
                    }, 400)
                    this.$refs.upload['value'] = ''
                    this.GetList()
                })
            } else {
                this.$Message.error('请输入内容或者导入文件')
            }
        },
        GetPlatform() {
            GetAllPlatform({}).then((res) => {
                let data = res._param.data || []
                let nlist = []
                data.map((item) => {
                    nlist.push({
                        value: item.id || 0,
                        name: item.name
                    })
                })
                this.select.platform_list = nlist
            })
        },
        GetList() {
            let params = { ...this.table.params }
            params.type = Number(params.type) === params.type ? Number(params.type) : -1
            SearchBlackPutInfo(params).then((res) => {
                let data = res._param
                this.table.data = data.list || []
                this.table['page_total'] = data.total
            })
        },
        ChangePage(page) {
            this.table.params.page = page
            this.table['page_current'] = page
            this.GetList()
        },
        ChangePageSize(page_size) {
            this.table.params.page = 1
            this.table['page_current'] = 1
            this.table.params.page_size = page_size
            this.GetList()
        },

        SearList() {
            this.table.params.page = 1
            this.$refs[this.table.ref]['currentPage'] = 1
            this.table['page_current'] = 1
            this.GetList()
        },

        // 编辑和新增
        OpenModal1(type, row = {}) {
            this.modal1.show = true
            this.modal1.form.data = { type: 1 }
        },
        CloseModal1() {
            // this.$refs[this.modal1.form.ref].resetFields();
            this.modal1.show = false
        },
        Update() {
            ExportBlackPutInfo({ ...this.modal1.form.data }).then((res) => {
                this.CloseModal1()
                this.GetList()
            })
        },

        readExcel(e) {
            //表格导入
            const files = e.target.files
            if (files[0].size > 1024 * 1024 * 1) {
                this.$Message.error('上传文件内容不能大于1M')
                return false
            }
            const fileReader = new FileReader()
            fileReader.onload = (ev) => {
                try {
                    this.modal1.form.data.data = ev.target.result
                    this.ExportBlackPutInfo()
                } catch (e) {
                    return false
                }
            }
            let charset = files[0].type == 'application/vnd.ms-excel' ? 'GBK' : 'utf-8'
            fileReader.readAsText(files[0], charset)
        },
        delAll() {
            this.$Modal.confirm({
                title: '删除',
                content: '是否全部删除',
                onOk: () => {
                    DelBlackPutInfo({}).then((res) => {
                        this.$Message.success('删除成功')
                        this.GetList()
                    })
                }
            })
        },
        OpenModal2(type, row = {}) {
            this.modal2.show = true
            this.OpenModal2['type'] = type
            this.modal2.form.data = { desc: '', ...row }
        },
        UpdateBlackPutInfo() {
            let params = { ...this.modal2.form.data }
            UpdateBlackPutInfo(params).then((res) => {
                this.CloseModal2()
                this.GetList()
            })
        },
        Delete(item) {
            let params = { ids: [item.id] }
            DelBlackPutInfo(params).then((res) => {
                this.CloseModal2()
                this.GetList()
            })
        },
        CloseModal2() {
            this.modal2.show = false
        }
    },
    created() {
        this.GetPlatform()
        this.GetList()
    },
    mounted() {
        this.$refs.upload.addEventListener('change', (e) => {
            //绑定监听表格导入事件
            this.readExcel(e)
        })
    }
}
</script>

<style lang="less">
#AppProxyPayModal {
    .ivu-form-item {
        margin-bottom: 10px;
    }
    .linesp span {
        display: inline-block;
        width: 100%;
        border: 1px solid #999;
        margin-bottom: 8px;
    }
}
</style>
<style scoped>
.outputlist_upload {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}
</style>
